import React, { useRef } from 'react';
import '../css/formats.css';
import { useReactToPrint } from "react-to-print";
import { Datos_Empresa, development } from "../libs/utils/Const";


export const FormatDeliveryModal = () => {

    const folio = "0000";
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Factura de reserva'+folio,
        onafterprint: () => alert('Print Success')
    })

    const Print = (id) =>{
        let printContents = document.getElementById(id).innerHTML;
        let originalContents = document.body.innerHTML;
        
        document.body.innerHTML = printContents;
        window.print();
        // this.openPointOfSale();
        document.body.innerHTML = originalContents; 
        // window.location.href = window.location.href;
        // window.location.reload();
        
    }
    // const { newOrderModel } = this.props;
    return (
        
        <div>
            <div className="modal fade" id="formatDeliveryModal"  data-keyboard="false" tabIndex="-1" aria-labelledby="formatInvoiceModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-xl" >
                    <div className="modal-content text-responsive">
                    <div className="modal-header">
                    </div> 
                    <div ref={componentRef} className="modal-body scrollPage" id="printInvoice">
                    <div className='mt-5' style={{height :"auto", width:"90%", marginLeft: "auto", marginRight:"auto"}}>
                                <div className="row">
                                    <div className="col-3">
                                        <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo"/>
                                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br/><strong>{Datos_Empresa.RFC}</strong></p>
                                    </div>
                                    <div className="col-6 text-center">
                                        <h4><strong>ENTREGA A DOMICILIO</strong></h4>
                                        <h4>(Por cobrar)</h4>
                                    </div>
                                    <div className="col-3">
                                        <span className="text-left">Sucursal:</span>
                                        <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br/>COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}</p>
                                    </div>  
                                </div>
                                <div className='row mt-5'>
                                    <div className='col-8'>
                                        <span>Fecha del documento: </span>
                                        <span>31/03/2022 06:28:48</span><br/>
                                        <span>Chofer: </span>
                                        <span>ARACELY GUTIERREZ MARTINEZ</span><br/><br/>
                                        <strong>
                                            <span>Cliente:</span><br/>
                                            <span className='ml-3'>CÓDIGO - ARACELY GUTIERREZ MARTINEZ</span><br/><br/>
                                            <span>Dirección de entrega:</span>
                                            <p className='ml-3'>
                                                Nombre de la calle #000<br/>
                                                Nombre de la colonia, Nombre del Municipio<br/>
                                                Nombre del estado y País<br/>
                                                C.P. 00000
                                            </p>
                                            <span>Teléfono: </span>
                                            <span className='ml-3'>555-555-5555</span>
                                        </strong>

                                        
                                       
                                    </div>
                                    <div className='col-4'>
                                    <table>
                                            <tbody>
                                                <tr>
                                                    <td>Fecha de impresión:</td>
                                                    <td>31/03/2022</td>
                                                </tr>
                                                <tr>
                                                    <td>Hora:</td>
                                                    <td>06:28:48p.m.</td>
                                                </tr>
                                                <tr>
                                                    <td>Folio:</td>
                                                    <td>A00000</td>
                                                </tr>
                                                <tr>
                                                    <td>Hoja:</td>
                                                    <td>1/1</td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-5' style={{paddingRight:"15px"}}>
                                    <div className='col-12'>
                                        <table>
                                            <thead style={{border: "solid 1px"}}>
                                                <tr>
                                                    <th className="text-center" style={{width:"6vw"}}> # </th>
                                                    <th>Número de artículo</th>
                                                    <th>Cantidad</th>
                                                    <th>Descripción</th>
                                                    <th className="text-center">Unidad de medida</th>
                                                    <th>Precio</th>
                                                    <th>Importe</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center ml-3 mr-3" style={{border: "solid 1px"}}>1</td>
                                                    <td style={{border: "solid 1px"}}>PP130C/20</td>
                                                    <td style={{border: "solid 1px"}}>PERFIL 130 C/20 M-600 (LM-P827)</td>
                                                    <td className="text-center" style={{border: "solid 1px"}}>Manual</td>
                                                    <td style={{border: "solid 1px"}}>1.00</td>
                                                    <td style={{border: "solid 1px"}}>$487.89</td>
                                                    <td style={{border: "solid 1px"}}>$487.89</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="5"></td>
                                                    <td >Subtotal: </td>
                                                    <td >$487.89</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="5"></td>
                                                    <td >I.V.A.: </td>
                                                    <td >$0.00</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="5"></td>
                                                    <td ><strong>Total: </strong></td>
                                                    <td ><strong>$487.89</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-5' style={{paddingRight:"15px"}}>
                                    <div className='col-12'>
                                        <h6 className='text-center'>CAMBIOS Y DEVOLUCIONES ÚNICAMENTE DENTRO DE LOS PRIMEROS 7 DÍAS CON LA NOTA</h6>
                                        <p>Debo(emos) incondicionalmente a la orden de {Datos_Empresa.Name}, en {Datos_Empresa.Ciudad} el dia miercoles, ## de septiembre 2022 la cantidad de $0.00 (LA CANTIDAD CON LETRA) Valor recibido a mí (nuestra) entera satisfacción de la mercancía. Este pagare es mercantil y está regido por la ley General de Títulos y Operaciones de Crédito en su artículo 173 parte final y artículos comelativos, por no ser pagaré domiciliado. Si este pagaré no es liquidado en su fecha de vencimiento , causará interés moratorio al 3% por ciento mensual, nos reservamos el derecho de cobrar el 20% sobre el importe por cheques devueltos.</p> 
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center">__________________________________________________________</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">ACEPTO</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handlePrint}>Imprimir</button>
                        
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormatDeliveryModal;